<div class="profiler-reports-root" #panelRoot>
  @if (queryItems.length === 0) {
    <div i18n="@@lowFiStatsUnavailable">
      Low-fi stats are unavailable for this profile type
    </div>
  }

  @if (selectedQueryItem) {
    <div class="report-section">
      <div
        class="image-container"
        [class.no-panel-header]="queryItems.length <= 1 && !title"
      >
        @if (queryItems.length > 1) {
          <div class="query-item-selector" id="{{ identifier }}">
            @for (row of queryItems; track row; let i = $index) {
              <span
                style="text-align: center"
                class="dot"
                [ngClass]="{ ' active': i === 0 }"
                (click)="selectQuery(i)"
              ></span>
            }
          </div>
        }

        @if (isAiAssistantEnabled$ | async) {
          <div class="ai-button">
            <button
              matSuffix
              mat-icon-button
              color="primary"
              class="icon button"
              (click)="onAiAssistantClicked()"
            >
              <span class="material-symbols-outlined">auto_awesome</span>
            </button>
          </div>
        }

        @if (title) {
          <div class="title">
            {{ title }}
          </div>
        }
        @if (selectedQueryItem.isStats) {
          <atlas-profiler-reports-stats
            class="report-content"
            [queryItem]="selectedQueryItem"
            [resizeTick]="resizeTick"
          ></atlas-profiler-reports-stats>
        }

        @if (selectedQueryItem.isGraph) {
          <atlas-profiler-reports-graph
            class="report-content"
            [pieGridView]="pieGridView"
            [numberCardView]="numberCardView"
            [height]="graphHeight"
            [queryItem]="selectedQueryItem"
            [graphConfig]="graphConfig"
            [resizeTick]="resizeTick"
            (graphClicked)="onGraphClicked($event)"
          >
          </atlas-profiler-reports-graph>
        }
      </div>
    </div>
  }
</div>
